import React from "react";

function Color_Metro_UI() {
  return (
    <div>
      <h1>Color_Metro_UI Component</h1>
      <p>This is the Color Metro UI tutorial page content.</p>
    </div>
  );
}

export default Color_Metro_UI;
